module.exports = __webpack_public_path__ + "static/img/duijiang.4015254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/duijiang.png
// module id = KhF4
// module chunks = 24